import api from "./axios";

export const getProductions =
() =>
api.get(
  "/production-orders"
);

export const createProduction =
(data)=>
api.post(
  "/production-orders",
  data
);